/*
 * @Author: 姚阳子 yaoyangzi@linhuiba.com
 * @Date: 2023-05-15 16:36:16
 * @LastEditors: 姚阳子 yaoyangzi@linhuiba.com
 * @LastEditTime: 2023-05-29 14:11:49
 * @FilePath: /locationpms-pc/src/filters/vueNumeralFilter/filters.ts
 * @Description:
 *
 *
 */
import numeral from 'numeral';
var abbreviate = function (value) { return numeral(value).format('0.0a'); };
var bytes = function (value) { return numeral(value).format('0 b'); };
var exposedNumeral = function (value, format) { return numeral(value).format(format); };
var exponential = function (value) { return numeral(value).format('0.[00]e+0'); };
var ordinal = function (value) { return numeral(value).format('Oo'); };
var percentage = function (value) { return numeral(value).format('0.[00]%'); };
var separator = function (value) {
    if (value === '' || value === null || value === undefined) {
        return '';
    }
    var valueStr = value.toString();
    var index = valueStr.indexOf('.');
    if (index === -1) {
        return numeral(value).format('0,0.00');
    }
    else {
        var values = valueStr.split('.');
        var decimals = values[1].padEnd(2, '0');
        return numeral(values[0]).format('0,0') + '.' + decimals;
    }
};
var separatorInt = function (value) { return numeral(value).format('0,0'); };
var currency = function (value) { return numeral(value).format('$0,0.00'); };
export { abbreviate, bytes, exponential, exposedNumeral, ordinal, percentage, separator, separatorInt, currency };
